export const TOKEN_KEY = "PalmaEmailToken";
export const USERDATA = "PalmaEmailUser";

export const isAuthenticated = () => {
  const token = getCookie('PalmaEmailToken');
  return token !== "";
};

export const getToken = () => {
  const token = getCookie('PalmaEmailToken');
  console.debug("getToken",token);
  return token;
};

export const getUser = () => {
  const user = getCookie('PalmaEmailUser');
  if (user !== "") {
    return JSON.parse(user); 
  } else {
    return null;
  }
};

export const getCookie = (cname) => {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}